import React, { useState } from "react";
import Masonry from "react-masonry-css";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";

const MasonryGallery = ({ images }) => {
  

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 1,
  };

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  return (
    <div>
      
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid mt-5"
        columnClassName="my-masonry-grid_column"
      >
        {images.map((src, index) => (
          <div key={index} className="masonry-item" onClick={() => openLightbox(index)}>
            <img
              src={src}
              alt={`v-strong contractor llc`}
              className="img-fluid rounded"
              style={{ cursor: "pointer" }}
            />
          </div>
        ))}
      </Masonry>

      {/* Lightbox Component */}
      {isOpen && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
        />
      )}
    </div>
  );
};

export default MasonryGallery;
